import {
  Children,
  createContext,
  SetStateAction,
  useState,
  Dispatch
} from 'react'
import classnames from 'classnames'

import styles from './_headerDropdown.module.scss'
interface HeaderDropdownProps {
  isHeaderDropdownOpen?: boolean
  setIsHeaderDropdownOpen: Dispatch<SetStateAction<boolean>>
}
export const HeaderDropdownContext = createContext<HeaderDropdownProps>({
  isHeaderDropdownOpen: false,
  setIsHeaderDropdownOpen: () => undefined
})
function HeaderDropdown({ children }) {
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const [trigger, ...items] = Children.toArray(children)

  return (
    <HeaderDropdownContext.Provider
      value={{
        isHeaderDropdownOpen: isOpen,
        setIsHeaderDropdownOpen: setIsOpen
      }}
    >
      <div
        className={classnames(styles.headerDropdown, isOpen && styles.isOpen)}
      >
        {trigger}
        <ul className={styles.headerDropdownList}>
          {items.map((item, index) => (
            <li key={`dropdown-item-${index}`}>{item}</li>
          ))}
        </ul>
      </div>
    </HeaderDropdownContext.Provider>
  )
}

export default HeaderDropdown
